import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig } from 'haba-core';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        CatalogModule: {
          module: () => import('./catalog.module').then((m) => m.CatalogModule),
          cmsComponents: ['ContentfulCatalogPageComponent'],
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          catalog: { paths: ['kataloganforderung'] },
        },
      },
    }),
  ],
})
export class CatalogFeatureModule {}
